
import defineConfig from "./defineConfig";

var parseUrl = function parseUrl() {
  var protocol = window.location.protocol;
  var host = window.location.host;
  return protocol + "//" + host;
};

var urlPre = process.env.NODE_ENV == "development" || process.env.NODE_ENV == "uat" ? "/api" : parseUrl();
console.log(process.env.NODE_EN);
console.log(urlPre);

var isProdZb = window.location.host === "vtmsz.essence.com.cn";

var isProd = window.location.host === "vtm.essence.com.cn" || isProdZb;

var httpConfig = {
  baseUrl: urlPre,

  reportUrl: isProd ? "https://vtmjk.essence.com.cn" : "https://vtmjkuat.axzq.com.cn"
};

var cordova = void 0;
var platform = typeof cordova === "undefined" ? "vtm" : cordova.platformId;
var isMobileFlag = false;

var qsVersion = defineConfig.$definecfg.QSJGDM_CONST.GUOTOU;

var isWin = false;

var isSm4Encrypt = false;

var bizPlatform = "1";

var runtimeType = "normal";

var baseConfig = {
  httpConfig: httpConfig,
  platform: platform,
  qsVersion: qsVersion,
  runtimeType: runtimeType,
  isWin: isWin,
  isSm4Encrypt: isSm4Encrypt,
  isMobileFlag: isMobileFlag,
  isProd: isProd,
  bizPlatform: bizPlatform
};

var plugin = {
  install: function install(Vue) {
    Vue.basecfg = baseConfig;

    Vue.prototype.$basecfg = baseConfig;
  },

  $basecfg: baseConfig
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/baseConfig.js
// module id = 32
// module chunks = 2